import { Component, OnInit, Input, ViewChild } from "@angular/core";
import {
    Device_SearchRequest,
    Device_UpdateRequest,
    DeviceInfo
} from "../../Models/RequestModels";
import { DeviceService } from "../../Services/DeviceService";
import { GenericMaster_String } from "../../Models/GlobalEntities";
import { MasterDataService } from "../../Services/MasterDataService";
import { CookieService } from "ngx-cookie-service";
import { NgbModalRef, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { QrCodeService } from "../../Services/QrCodeService";

@Component({
    selector: "DeviceSearchResult",
    templateUrl: "./DeviceSearchResult.html"
})
export class DeviceSearchResult implements OnInit {
    @ViewChild('content') content:any;
    _RequestModel: Device_SearchRequest;
    SortParams: Array<GenericMaster_String> = [];
    CurrentPageNumber: number = 1;
    TotalRecords: number;
    Cache_AllDevices: any[];
    FilteredData: any[];
    DevicesForView: any;
    IsSubmitting: boolean;
    SortByText: string = "";
    ModalRef: NgbModalRef;
    Progress: number = 1;
    IdentifierToken: string;

    constructor(
        public deviceService: DeviceService,
        public masterService: MasterDataService,
        public cookieService: CookieService,
        public modalService: NgbModal,
        public qrCodeService: QrCodeService
    ) {}

    ngOnInit() {
        this.RequestModel.DeviceStatus = 0;
        this.CreateSortParams();
        this.deviceService.ActivationProgress.subscribe(data => {
            this.Progress = data;
            if(this.Progress == 0){
                this.Progress = 1;
            }
            if(this.Progress == 100){
                this.SetData();
                this.closeModal();
            }
        });
        this.getIdentifierToken();
    }

    @Input("RequestModel") set RequestModel(Model: Device_SearchRequest) {
        this._RequestModel = Model;
    }

    get RequestModel(): Device_SearchRequest {
        return this._RequestModel;
    }

    @Input() Show(): void {
        this.SetData();
    }

    CreateSortParams(): void {
        this.SortParams = [
            { Id: "None", Name: "" },
            { Id: "IdentifierToken asc", Name: "BTN.BTN_IDENTIFIER_TOKEN_ASC" },
            { Id: "IdentifierToken desc", Name: "BTN.BTN_IDENTIFIER_TOKEN_DSC" }
        ];
    }

    SetData(): void {
        this.IsSubmitting = true;
        let req = {
            PropertyID: this.masterService.ActivePropertyID
        };
        this.deviceService
            .Device_Search(req)
            .then(data => {
                this.Cache_AllDevices = data.Result;
                this.FilterData();
                this.SortData();
                this.onPageChange();
                this.IsSubmitting = false;
            })
            .catch(reason => {
                this.IsSubmitting = false;
                console.info(reason);
            });
    }

    UpdateDeviceStatus(device: any) {
        var req = new Device_UpdateRequest();
        req.PropertyID = this.masterService.ActivePropertyID;
        req.WebSessionIDs = [];
        let sessionId = device.WebSessionID;
        req.WebSessionIDs.push(sessionId);
        req.DeviceStatus = !device.DeviceStatus;
        this.deviceService
            .Device_Update(req)
            .then(data => {
                this.SetData();
            })
            .catch(reason => {
                console.info(reason);
            });
    }

    DeactivateAllDevices() {
        this.openModal();
        var req = {
            PropertyID: this.masterService.LoggedInUserData.PropertyId
        };
        this.deviceService
            .Deactivate_Devices(req)
            .then(data => {
                if (data && !data.HasError) {
                    if (data.Result) {
                        // this.SetData();
                        console.log(data);
                    }
                }
                else{
                    this.closeModal();
                }
            })
            .catch(reason => console.info(reason));
    }

    SortData(id?) {
        if (id != null) {
            this.SortByText = id;
        }
        switch (this.SortByText) {
            case "None": {
                this.SortByText = "None";
                this.FilterData();
                return;
            }
            case "IdentifierToken asc": {
                this.FilteredData.sort(
                    this.CompareFunction("IdentifierToken", "asc")
                );
                break;
            }
            case "IdentifierToken desc": {
                this.FilteredData.sort(
                    this.CompareFunction("IdentifierToken", "desc")
                );
                break;
             }
            default:
                break;
        }
        this.onPageChange();
    }

    CompareFunction(prop, dir) {
        return function(a, b) {
            var nameA = a[prop].toUpperCase(); // ignore upper and lowercase
            var nameB = b[prop].toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return dir == "asc" ? -1 : 1;
            }
            if (nameA > nameB) {
                return dir == "asc" ? 1 : -1;
            }

            return 0;
        };
    }

    FilterData() {
        this.FilteredData = [];
        if (this.RequestModel.DeviceStatus == 0) {
            this.FilteredData = this.Cache_AllDevices.slice(0);
        }
        if (this.RequestModel.DeviceStatus == 1) {
            this.FilteredData = this.Cache_AllDevices.filter(
                x => x.DeviceStatus
            );
        }
        if (this.RequestModel.DeviceStatus == 2) {
            this.FilteredData = this.Cache_AllDevices.filter(
                x => !x.DeviceStatus
            );
        }
        if (this.RequestModel.Keyword) {
            this.FilteredData = this.FilteredData.filter(x =>
                x.IdentifierToken.toLowerCase().includes(
                    this.RequestModel.Keyword
                )
            );
        }
        this.onPageChange();
    }

    onPageChange() {
        let startIndex = (this.CurrentPageNumber - 1) * 25;
        // let endIndex = startIndex + this.RequestModel.PageSize;
        let endIndex = startIndex + 25;
        this.DevicesForView = this.FilteredData.slice(startIndex, endIndex);
    }

    RefreshData() {
        this.RequestModel.DeviceStatus = 0;
        this.SortByText = "None";
        this.SetData();
    }

    openModal(){
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };    
        this.ModalRef = this.modalService.open(this.content,ngbModalOptions);
    }

    closeModal(){
        this.ModalRef.close();
        this.Progress = 1;
    }

    getIdentifierToken(){
        this.IdentifierToken = this.qrCodeService.getidentifierToken();
    }

}
